'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { getCookieBunja, type CookieKey } from '@flipster/utils/cookie';

export function useCookie(key: CookieKey) {
  const { cookieAtom, update, remove } = useBunja(getCookieBunja(key));
  const cookieValue = useAtomValue(cookieAtom);

  return [cookieValue, update, remove] as const;
}
